import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { InfoAltIcon } from '../../icons';
import Dialog from '../../shared/dialog';

interface Props {
  label: string;
  description: string;
  backgroundColor?: string;
}

const Container = styled(Box)({
  visibility: 'visible',
  width: '3%',
  color: '#aaa',
  paddingTop: 10,
  marginLeft: '-6px',
  fill: '#ccc',
  float: 'right',
  cursor: 'pointer',

  ':hover': {
    fill: '#444',
  },

  '@phone': {
    display: 'block',
    position: 'absolute',
    right: 32,
    top: 0,
    width: 16,
    height: 16,
    zIndex: 10,
  },
});

const FieldDescriptionButton: React.FC<Props> = ({ label, description, backgroundColor = '#fff' }) => {
  const [showDescription, setShowDescription] = useState(false);

  return (
    <Container
      sx={{ backgroundColor }}
      title={description}
      onClick={(event) => {
        event.stopPropagation();
        setShowDescription(true);
      }}
    >
      <InfoAltIcon data-testid="InfoAltIcon" style={{ display: 'inline-block', width: 16, height: 16 }} />
      <Dialog
        data-testid="field-description-dialog"
        show={showDescription}
        title={label}
        onPositiveClick={(event) => {
          event.stopPropagation();
          setShowDescription(false);
        }}
        negativeHidden
      >
        <div>{description}</div>
      </Dialog>
    </Container>
  );
};

export default FieldDescriptionButton;
